module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJhc3NldHMvYmFja2dyb3VuZC5jYWYwOTVlMC5wbmciOw=="